import { render, staticRenderFns } from "./zibalVerify.vue?vue&type=template&id=47295d42&scoped=true&"
import script from "./zibalVerify.vue?vue&type=script&lang=js&"
export * from "./zibalVerify.vue?vue&type=script&lang=js&"
import style0 from "./zibalVerify.vue?vue&type=style&index=0&id=47295d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47295d42",
  null
  
)

export default component.exports